import Label from 'semantic-ui-react/dist/commonjs/elements/Label';
import '@purple/semantic-ui-purple-theme/components/label.css';

export default Label;
